import { useSyncExternalStore } from 'react';
import type { Store, SystemStatus } from './Store';

/**
 * Subscribes to a Store's system status (realtime health, schema version
 * mismatch, last dispatch error). Re-renders the consuming component when
 * any of those fields change. Same subscribe channel as useAppState.
 */
export function useSystemStatus(store: Store): SystemStatus {
  return useSyncExternalStore(store.subscribe, store.getSystemStatus);
}
